const { ofetch } = require("ofetch");

$(function() {
    const $gridContent1BDynamic = $('.component-grid-content-1B__content_blocks--dynamic');
    const fetchData = function() {
        $gridContent1BDynamic.each(async function(index, element) {
            var $element = $(element);

            const action = $element.data('grid-content-1b-fetch');
            const response = await ofetch(action, {
                method: "GET",
            });
            //console.log(response)
            $element.html(response);
            //$element.height($element.outerHeight());
            //$element.html(response).flickity(carousel1BParams);
            //window.setTimeout(function() {
            //    $element.height('auto');
            //},1000)
        })
    }

    fetchData();
});
